import { SitecoreClient } from '@sitecore-content-sdk/nextjs/client';
import scConfig from 'sitecore.config';

/**
 * Singleton SitecoreClient instance.
 * Replaces the separate LayoutServiceFactory, DictionaryServiceFactory,
 * GraphQLEditingService, and GraphQLRequestClientFactory that existed in JSS.
 *
 * Usage:
 *   client.getPage(path, { locale })
 *   client.getPreview(previewData)
 *   client.getDictionary({ site, locale })
 *   client.getComponentData(layout, context, components)
 *   client.getPagePaths(siteNames, locales)
 *   client.getData<T>(query, variables)
 */
const client = new SitecoreClient({
  ...scConfig,
});

export default client;
